import Vue from 'vue';

export function stringPxLength (str){
  const checkEl = document.getElementById('ruler');
  checkEl.innerText = str;
  return checkEl.offsetWidth;
}

export function createWithLinkHOC (getLink) {
  return (component) => Vue.component('WithLinkHOC', {
    props: component.props,
    render (createElement) {
      return createElement(component, {

        // pass default cell props + url prop
        props: {
          ...this.$props,
          url: getLink(this.$props.tableRow)
        }
      });
    }
  });
}

export function getComponentOptions (component) {
  return component.componentOptions;
}

export function getComponentData (component) {
  return component.data;
}

export function getProps (component) {
  return getComponentOptions(component).propsData;
}

export function getListeners (component) {
  return getComponentOptions(component).listeners;
}

export function getAttrs (component) {
  return getComponentData(component).attrs;
}

export function booleanProp (prop, def = false) {
  // boolean attribute can be "" if present in this form: `<div prop />`
  return prop === '' || (prop === undefined ? def : Boolean(prop));
}
